export default "__VITE_ASSET__CuZY6qGP__"